import { ProductCategoryEnum } from '@mwe/constants';
import { isProductCategory } from '@mwe/utils';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { Product } from '@mwe/models';

import { TranslateDirective } from '@ngx-translate/core';
import { ProductCardTariffListFernwaermeComponent } from './product-card-tariff-list-fernwaerme.component';
import { TariffClassLineBreakPipe, TranslateCategoryPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-product-card-tariff-list',
  templateUrl: './product-card-tariff-list.component.html',
  imports: [TranslateDirective, ProductCardTariffListFernwaermeComponent, TranslateCategoryPipe, TariffClassLineBreakPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardTariffListComponent {
  product = input<Product>();
  tariffClasses = input<string[]>();
  showWaermeTariffClassesAsideOfIcon = input<boolean>(false);

  isProductCategory = isProductCategory;
  productCategoryEnum = ProductCategoryEnum;

  constructor() {}
}
